module.exports = __webpack_public_path__ + "img/28c35cf.png";